import moment from 'moment';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import styleConstants from 'styles/style-constants';
export var getStatusColor = function (status) {
    switch (status) {
        case 'Running':
            return styleConstants.colors.primary.DEFAULT;
        case 'Expired':
            return styleConstants.colors.danger;
        case 'Warning':
            return styleConstants.colors.warning.DEFAULT;
        default:
            return '';
    }
};
var StatusIcon = function (_a) {
    var status = _a.status, tooltipText = _a.tooltipText;
    return React.createElement(Popup, { inverted: true, position: "left center", trigger: React.createElement("div", { style: {
                width: 12,
                height: 12,
                display: 'inline-block',
                background: getStatusColor(status),
                borderRadius: '50%',
            } }) },
        React.createElement("span", { className: "font-x-small" }, tooltipText));
};
export var IDColumn = function (_a) {
    var data = _a.data;
    if (data.status === 'PENDING') {
        return React.createElement(StatusIcon, { status: "Warning", tooltipText: "Launching" });
    }
    var hoursToExpire = moment(data.expires).diff(moment(), 'hours', true);
    var status = hoursToExpire > 12 ? 'Running' : 'Warning';
    var statusText = hoursToExpire > 12 ? 'Running' : 'Expiring soon';
    if (hoursToExpire <= 0) {
        status = 'Expired';
        statusText = 'Expired';
    }
    return React.createElement(StatusIcon, { status: status, tooltipText: statusText });
};
export default IDColumn;
